module.exports = __webpack_public_path__ + "static/media/book1.3a8eadd3.svg";